import { BtcGameAsset } from '@optools/services/operator-gateway/btc/types';
import {
  PipelineStatus,
  StreamState,
} from '@optools/services/operator-gateway/types/generated/graphql';

export const generateAssetKey = (asset: BtcGameAsset) => `${asset.assetId}-${asset.cdn}`;

export const canIngestAssetIntoDai = (pipelineStatus: PipelineStatus, streamState: StreamState) => {
  return (
    pipelineStatus === PipelineStatus.RUNNING ||
    (pipelineStatus === PipelineStatus.WARNING &&
      [StreamState.PROGRAM_ON, StreamState.STREAM_ON, StreamState.PROGRAM_DONE].includes(
        streamState,
      ))
  );
};
